export default [
  {
    path: '/order/logistics/:mailNo',
    name: 'order',
    meta: {hideTab:true },
    component: () => import('@/views/logistics/index.vue'),

  }
]